<div class="main-box">
    <div [formGroup]="templateForm">
        <a (click)="backToTemplateList()">
            <p>back to the list</p>
        </a>
        <p-button label="Submit" (onClick)="sendForm()"></p-button>
        <table>
            <tr>
                <td>
                    Template name*
                </td>
                <td>
                    <input pInputText placeholder="Name" type="text" formControlName="name">
                </td>
            </tr>
            <tr>
                <td>
                    Content*
                </td>
                <td>
                    <textarea class="raw-editor" formControlName="body"></textarea>
                </td>
            </tr>
        </table>
    </div>
</div>